import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "data-fields" }
const _hoisted_2 = ["onBlur"]
const _hoisted_3 = ["value", "onInput"]


export default /*@__PURE__*/_defineComponent({
  __name: 'DataBlock',
  props: {
    block: {},
    pageIndex: {},
    blockIndex: {}
  },
  emits: ["update", "contentEdit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function updateTitle(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { title: target.innerText });
  emit("contentEdit");
}

function updateFieldLabel(index: number, event: Event) {
  const target = event.target as HTMLElement;
  const newFields = [...props.block.data.fields];
  newFields[index].label = target.innerText;
  emit("update", { fields: newFields });
  emit("contentEdit");
}

function updateFieldValue(index: number, event: Event) {
  const target = event.target as HTMLInputElement;
  const newFields = [...props.block.data.fields];
  newFields[index].value = target.value;
  emit("update", { fields: newFields });
  emit("contentEdit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "data-block",
    style: _normalizeStyle(__props.block.style)
  }, [
    _createElementVNode("h3", {
      contenteditable: "true",
      onBlur: updateTitle
    }, _toDisplayString(__props.block.data.title), 33),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.data.fields, (field, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "data-field"
        }, [
          _createElementVNode("label", {
            contenteditable: "true",
            onBlur: ($event: any) => (updateFieldLabel(index, $event))
          }, _toDisplayString(field.label), 41, _hoisted_2),
          _createElementVNode("input", {
            value: field.value,
            onInput: ($event: any) => (updateFieldValue(index, $event)),
            class: "data-input"
          }, null, 40, _hoisted_3)
        ]))
      }), 128))
    ])
  ], 4))
}
}

})